import {useEffect} from 'react';
import {useSelector} from 'react-redux';

import * as routePaths from '../../consts/route/routePaths';
import ModalTypes from '../../enums/app/modalTypes';
import hidReconnectHandlerService from '../../services/hid/hidReconnectHandlerService';
import routerService from '../../services/routerService';
import {hideModalAction} from '../../state/ducks/modal';
import {selectIsDeviceReady} from '../../state/selectors/iotDevice';
import {dispatch} from '../../state/store';

const HIDE_RECONNECT_PAGES = [
    routePaths.CONNECTION_SELECTION,
    routePaths.ACTIVATION,
    routePaths.ERROR_PAGE,
    routePaths.PAIRING_GUIDE,
    routePaths.REGISTRATION,
    routePaths.SELECT_DEVICE,
    routePaths.SYNC,
    routePaths.USAGE_STATS,
    routePaths.ADVANCED_DIAGNOSTIC,
];

export const useHidReconnectHidden = () => {
    const location = routerService.getCurrent();
    const isDeviceReady = useSelector(selectIsDeviceReady);

    useEffect(() => {
        const routePath = `/${location.split('/')[1]}`;
        const isHide = HIDE_RECONNECT_PAGES.find((page) => routePath === page || location === page);

        if (isHide) {
            hidReconnectHandlerService.setCustomOHandler();
        } else {
            hidReconnectHandlerService.clearCustomHandlerAndShowReconnectModal();
        }
    }, [location]);

    useEffect(() => {
        if (isDeviceReady) {
            dispatch(hideModalAction(ModalTypes.HID_RECONNECT));
        }
    }, [isDeviceReady]);
};

export const useHidClearHandler = () => {
    useEffect(() => {
        return () => {
            hidReconnectHandlerService.clearHidReconnectHandlerState();
            hidReconnectHandlerService.clearCustomHandlerAndShowReconnectModal();
        };
    }, []);
};
